import { PolicyViolationsCountMap } from '@agilelab/plugin-wb-governance-common';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import { WbInfoTooltip } from '../WbInfoTooltip';
import SyncProblemOutlinedIcon from '@material-ui/icons/SyncProblemOutlined';
import clsx from 'clsx';
import { CSSProperties } from 'react';
import { FlagBoxContent } from './FlagBoxContent';

export const flagBoxUseStyles = makeStyles(theme =>
  createStyles({
    iconBase: {
      display: 'block',
    },
    infoIcon: {
      color: theme.palette.info.main,
    },
    warningIcon: {
      color: theme.palette.warning.main,
    },
    errorIcon: {
      color: theme.palette.error.main,
    },
    unavailableFlagsIcon: {
      color: theme.palette.softened.secondary,
    },
  }),
);

export type FlagBoxProps = {
  externalId: string;
  policyViolationsCountMap?: PolicyViolationsCountMap;
  error?: Error;
  loading?: boolean;
  iconStyle?: CSSProperties;
};

export const FlagBox = (props: FlagBoxProps) => {
  const { loading, error, policyViolationsCountMap } = props;
  const classes = flagBoxUseStyles();

  if (loading) return <></>;

  const policyViolationsOutcomeMap =
    policyViolationsCountMap?.get(props.externalId) ?? new Map();

  return (
    <Box>
      {error && (
        <WbInfoTooltip
          title="Flags are temporarily unavailable"
          icon={
            <SyncProblemOutlinedIcon
              role="img"
              aria-hidden="false"
              aria-label="Flags are temporarily unavailable"
              style={props.iconStyle}
              className={clsx(classes.iconBase, classes.unavailableFlagsIcon)}
            />
          }
        />
      )}

      <FlagBoxContent
        policyViolationsOutcomeMap={policyViolationsOutcomeMap}
        iconStyle={props.iconStyle}
      />
    </Box>
  );
};
